import React from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

import SkeletonCards from '../SkeletonSuggestionCard/SkeletonCards.jsx';

type PanelContentProps = React.PropsWithChildren<{
  isLoading: boolean;
  isEmpty: boolean;
  isRecoRobot?: boolean;
}>;

const PanelContent = ({
  isLoading,
  isEmpty,
  isRecoRobot,
  children,
}: PanelContentProps) => {
  const { t } = useTranslation('@mint-lib/recommendations-circuit');

  if (isLoading) {
    return <SkeletonCards isRecoRobot={isRecoRobot} />;
  }

  if (isEmpty) {
    return (
      <p
        className={cn(
          typographyVariants({
            variant: 'h4',
          }),
          'p-3 text-center',
        )}
      >
        {t('No suggestions for this tab.')}
      </p>
    );
  }

  return children;
};

export default PanelContent;
